// Note: performance.now() and Date.now() have different time origins.
const now = window?.performance?.now.bind(window.performance) || Date.now;

function makeApiEventName(
    timingCategory: string, timingVar: string, suffix: string): string {
    return `${timingCategory}_${timingVar}_${
        suffix}`.toLowerCase().replaceAll(' ', '_');
}

export default class LoggedTimer {
    context: jsx.AppGlobals;
    timers: Record<string, number>;

    constructor(context: jsx.AppGlobals) {
        this.context = context;
        this.timers = {};
    }
    getReqScopedKey(timingCategory: string, timingVar: string): string {
        return `${this.context.request.localLogReqId}:${
            this.context.request.preRendering}:${
            timingCategory}:${timingVar}`;
    }
    time(timingCategory: string, timingVar: string, apiEventName?: string) {
        const key = this.getReqScopedKey(timingCategory, timingVar);
        if (key in this.timers) {
            console.error(`${key} timer already defined`);
            return;
        }
        console.time(key);
        this.timers[key] = now();
        if (process.env.BROWSER) {
            const eventName = apiEventName ||
                makeApiEventName(timingCategory, timingVar, 'start');
            this.context.apiService.registerEvent(eventName);
        }
    }
    timeEnd(timingCategory: string, timingVar: string, apiEventName?: string) {
        const key = this.getReqScopedKey(timingCategory, timingVar);
        if (!(key in this.timers)) {
            console.error(`${key} timer not defined`);
            return;
        }
        console.timeEnd(key);
        if (process.env.BROWSER) {
            const timingValue = now() - this.timers[key];
            window.gaTiming({
                category: timingCategory,
                name: timingVar,
                value: timingValue,
            });
            const eventName = apiEventName ||
                makeApiEventName(timingCategory, timingVar, 'done');
            this.context.apiService.registerEvent(eventName, {
                timing_milliseconds: timingValue.toString(),
            });
        }
        delete this.timers[key];
    }
}
